import PartyHasAlreadyJoinedError from './PartyHasAlreadyJoinedError.js'
import SessionExpiredError from './SessionExpiredError.js'

/**
 * Turns a con:join error of the signaling server into a known error, or returns it unchanged.
 * Signaling has no code for an expired session: it passes the platform's refusal on as a generic error whose message
 * holds the platform's answer, e.g. `403 Forbidden: "{..."errorCode":"sessionExpired"}"`.
 */
export default function classifyJoinError(error) {
  const message = typeof error?.message === 'string' ? error.message : ''
  if (message === 'PARTY_HAS_ALREADY_JOINED') {
    return new PartyHasAlreadyJoinedError('User is already in session', error)
  }
  if (message === 'SESSION_EXPIRED' || message.includes('sessionExpired')) {
    return new SessionExpiredError('Session expired', error)
  }
  return error
}
